import React from 'react';
import DashboardReferenceWidgetBuilder from './DashboardReferenceWidgetBuilder';
import DashboardReferenceWidgetRenderer from './DashboardReferenceWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { DashboardReferenceWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';

export { default as DashboardReferenceWidgetBuilder } from './DashboardReferenceWidgetBuilder';
export { default as DashboardReferenceWidgetRenderer } from './DashboardReferenceWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'dashboard_reference',
  meta: {
    label: 'Dashboard Reference',
    icon: React.createElement(FontAwesomeIcon, { icon: faLink }),
    description: 'Reference data from widgets on other dashboards',
    isSystem: true,
    isCreatable: false,
    dataFlow: 'both',
  },
  defaultSize: { w: 6, h: 5, minW: 3, minH: 3 },
  defaultConfig: () => ({
    sourceDashboardId: null,
    sourceDataKey: null,
    sourceWidgetType: null,
    readOnly: true,
    displayTitle: undefined,
  } as DashboardReferenceWidgetConfig),
  Builder: DashboardReferenceWidgetBuilder,
  Renderer: DashboardReferenceWidgetRenderer,
  Preview,
};
